import DatePicker from './DatePicker'
import DatePickerRange from './DatePickerRange'
import DateTimepicker from './DateTimepicker'
import TimePicker from './TimePicker'
import Calendar from './Calendar'
import RangeCalendar from './RangeCalendar'

DatePicker.DatePickerRange = DatePickerRange
DatePicker.DateTimepicker = DateTimepicker
DatePicker.TimePicker = TimePicker

export { Calendar, RangeCalendar }

export default DatePicker
